import { SORTING_TYPES } from '../constants';

export const between = (x: number, min: number, max: number) => (
  x >= min && x <= max
);

export const checkIsAscSorting = (sortingType: string = '') => (
  sortingType === SORTING_TYPES.ascending
);

export const checkIsIntegerNumber = (value: string) => (
  !!value && /^([0-9]+)$/.test(value)
);

export const checkIsFloatNumber = (value: string) => (
  !!value && (checkIsIntegerNumber(value) || /^(\d{1,}\.\d{0,})$/.test(value))
);
